import { Box, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';
import { memo } from 'react';
import { IDataWheelPickerSelect, WheelPicker } from './whellPicker';
import { IoClose } from 'react-icons/io5';

interface IOwnProps {
  isOpen: boolean;
  onClose(): void;
  data: IDataWheelPickerSelect[];
  onSelectItem(item: IDataWheelPickerSelect): void;
  selectedItem?: IDataWheelPickerSelect;
}

const ModalizeSelectInput: React.FC<IOwnProps> = ({ isOpen, onClose, data, selectedItem, onSelectItem }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.400" />
      <ModalContent
        color="white"
        position="absolute"
        bottom={0}
        w="100%"
        maxW="100dvw"
        borderRadius="10px 10px 0 0"
        overflow="hidden"
        p={0}
        m={0}
        background="#272727"
      >
        <ModalBody p={0} zIndex={9}>
          <Flex position="relative" align="center" justify="center" py={6}>
            <Text textAlign="center" fontSize="lg" color="gray">
              Selecione um item
            </Text>

            <Box
              position="absolute"
              right={4}
              color="gray"
              transform="translateY(-50%)"
              onClick={onClose} // sua função de fechar o modal
            >
              <IoClose />
            </Box>
          </Flex>
          <WheelPicker items={data} value={selectedItem} onChange={onSelectItem} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(ModalizeSelectInput);
